import { Component, inject, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ServiceCardsService } from '../../services/service-cards.service';
import { MatButtonModule } from '@angular/material/button';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-modal-qr',
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './modal-qr.component.html',
  styleUrl: './modal-qr.component.css'
})
export class ModalQrComponent implements OnInit {

  readonly dialog = inject(MatDialog);
  @Input() dialogRef: MatDialogRef<ModalQrComponent> = inject(MatDialogRef);

  public qrCodeImage: string = '';

  constructor(
    private cardsService: ServiceCardsService,
  ) {
  }

  ngOnInit(): void {
    if (this.cardsService.getCurrentCard() === null) {
      this.dialogRef.close();
    }
    const card = this.cardsService.getCurrentCard();

    this.cardsService.generateQrCode(card.id)
      .subscribe((response: any) => {
        console.log(response);
        this.qrCodeImage = response.qrcode;
      });
  }

  downloadQrCode() {
    const card = this.cardsService.getCurrentCard();

    const fileName = `qrcode_${card.id}_.png`;

    this.downloadBase64File(this.qrCodeImage, fileName);
  }

  downloadBase64File(contentBase64: string, fileName: string) {

    saveAs(contentBase64, fileName);

  }


}
